var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid h-100",attrs:{"id":"app"}},[_c('Navbar'),_c('AuthNav'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }